import { DsIcon } from '@descomplica/design-system-react';
import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { MicrofrontendViewModel } from '@/shared/presentation/Microfrontend.vm';

export const MenuWrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;

  @media (max-width: 480px) {
    gap: 32px;
  }
`;

export const MenuItem = styled.div<Pick<Item, 'selected'>>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  position: relative;
  padding: 0 16px;
  gap: 16px;
  height: 100%;
  cursor: pointer;
  max-width: 240px;

  & .ds-icon {
    background-color: white !important;
  }

  & span {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.6px;
    font-weight: ${({ selected }) => (selected ? '700' : 'normal')};
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    bottom: 0;
    background: ${({ selected }) => (selected ? 'var(--green-principal)' : 'initial')};
  }

  &:hover {
    &::before {
      background: var(--green-principal);
    }
  }

  @media (max-width: 480px) {
    margin-right: 0;
    padding: 0;

    & span {
      display: none;
    }
  }
`;

export const Icon = styled.img`
  margin-right: 12px;
`;

export type Item = {
  label: string;
  icon: string;
  page: string;
  selected?: boolean;
};

export const HeaderMenu: React.FC = observer(() => {
  const location = useLocation();
  const navigate = useNavigate();

  const vm = useViewModel(MicrofrontendViewModel);

  const accountNameOrEmail = useMemo(
    () => (vm.account ? vm.account.name || vm.account.email : ''),
    [vm.account],
  );

  const openDashboard = () => {
    navigate('/');
  };

  const openAdmin = () => {
    navigate('/admin');
  };

  const openAccount = () => {
    navigate('/account');
  };

  if (!vm.account) {
    return null;
  }

  return (
    <MenuWrapper>
      <MenuContainer>
        {vm.accountGrants && !vm.accountGrants.canNotViewHomeButton && (
          <MenuItem onClick={openDashboard} selected={location.pathname === '/'}>
            <DsIcon image="home" />
            <span>Início</span>
          </MenuItem>
        )}

        {vm.accountGrants && vm.accountGrants.canViewControlPanelAdmin && (
          <MenuItem onClick={openAdmin} selected={location.pathname.startsWith('/admin')}>
            <DsIcon image="settings" />
            <span>Administração</span>
          </MenuItem>
        )}

        <MenuItem onClick={openAccount} selected={location.pathname.startsWith('/account')}>
          <DsIcon image="account" />
          <span>{accountNameOrEmail}</span>
        </MenuItem>
      </MenuContainer>
    </MenuWrapper>
  );
});
